// extracted by mini-css-extract-plugin
export default {"section":"PageStock_section__W0q+a","data":"PageStock_data__GXcZt","notAvailable":"PageStock_notAvailable__zw8fY"};